import { create } from 'zustand';
import { hojeISO } from '../utils/masks';

const EMPTY_FORM = {
  // IDENTIFICAÇÃO
  comarca: '',
  interview_date: hojeISO(),
  action_type: 'Reclamação Trabalhista',
  entrevistado_por: '',            // campo complementar — fichas reais (task 3.4)
  documentos_faltantes: '',        // campo complementar — fichas reais (task 3.4)
  ai_hint_identificacao: '',

  // RECLAMANTE
  claimant_name: '',
  claimant_cpf: '',          // armazenado como dígitos puros
  claimant_rg: '',
  claimant_rg_issuer: '',
  claimant_birth_date: '',
  // 'F' | 'M' — flexiona a qualificação e as seções fixas; nunca deduzido do nome.
  claimant_gender: '',
  claimant_mother_name: '',
  claimant_occupation: '',
  claimant_education: '',
  claimant_ctps_number: '',
  claimant_ctps_serie: '',
  claimant_ctps_uf: '',
  claimant_pis: '',          // dígitos puros
  claimant_address: '',
  claimant_neighborhood: '',
  claimant_city: '',
  claimant_state: '',
  claimant_zip: '',          // dígitos puros
  claimant_email: '',
  // Telefones múltiplos
  claimant_phones: [
    { id: 'ph_1', number: '', type: 'cel', is_whatsapp: true },
  ],
  ai_hint_reclamante: '',

  // RECLAMADOS (lista dinâmica)
  defendants: [
    {
      id: 'def_1',
      name: '',
      cnpj: '',              // dígitos puros
      cpf: '',               // dígitos puros
      gender: '',            // 'F' | 'M' — só para empregador pessoa física
      cei: '',               // dígitos puros
      address: '',
      neighborhood: '',
      city: '',
      state: '',
      zip: '',               // dígitos puros
      is_primary: true,
      relationship: 'main',
      order_num: 1,
      phones: [],            // [{ id, number (dígitos), type }]
      extra_info: '',        // dados extras do reclamado
    },
  ],
  ai_hint_reclamado: '',

  // CONTRATOS (lista dinâmica)
  contracts: [
    {
      id: 'ct_1',
      defendant_id: 'def_1',
      hire_date: '',
      termination_date: '',
      ultimo_dia_trabalhado: '',
      contracted_role: '',
      actual_roles: '',
      registered_salary: '',     // decimal string ex: "3405.00"
      off_payroll_salary: '',    // decimal string
      dismissal_type: '',
      registered_in_ctps: true,
      fgts_deposited: true,
      food_benefit: false,
      transport_benefit: false,
      health_plan: false,
      meal_benefit: false,
      other_benefits: '',
      severance_amount: '',      // decimal string
      severance_payment_date: '',
      notes: '',
      order_num: 1,
      // Regime e jornada do CONTRATO (1.21): a ficha pode ter mais de um vínculo, e no caso-piloto
      // (doméstica de 30 horas — relatório do Dr. Lucas de 23/09/2026) a peça saiu CLT de 44 horas.
      // Vazio = CLT urbano de 8h/44h, a conta de antes.
      regime_contratual: '',
      jornada_contratual_diaria_horas: '',
      jornada_contratual_semanal_horas: '',
    },
  ],
  remuneracao_periodos: [],
  ferias_vencidas_nao_gozadas: '',
  ai_hint_contrato: '',

  // Campos complementares do contrato — fichas reais (task 3.4)
  local_prestacao_servico: '',      // pode diferir do local de contratação (casos rurais)
  local_contratacao: '',
  cultura_fazenda: '',               // cultura produzida pela fazenda (casos rurais)
  contrato_experiencia: false,       // assinou contrato de experiência
  clausula_assecuratoria: false,     // experiência com cláusula do art. 481: a rescisão antecipada tem aviso (1.26.1)
  seguro_desemprego_durante_vinculo: false, // recebeu seguro-desemprego enquanto trabalhava
  forma_recebimento_salario: '',     // dinheiro | pix | deposito
  pedido_reconhecimento_vinculo: false, // pedido de vínculo de emprego (quando sem registro)

  // JORNADA
  work_days: { seg: true, ter: true, qua: true, qui: true, sex: true, sab: false, dom: false },
  work_day_schedules: {}, // chave = 'seg'|'ter'|..., valor = { start, end, interval } ou undefined p/ usar padrão
  // Jornada que mudou no curso do contrato: cada período vira uma tabela na petição e uma linha
  // na memória de cálculo das horas extras. Vazio = jornada única (campos abaixo).
  jornada_periodos: [],
  shift_start: '',
  shift_end: '',
  intrajornada_interval_minutes: '',
  point_control_type: '',
  point_irregularities: '',
  overtime_frequency: '',
  overtime_description: '',
  overtime_end_time: '',
  saturday_work: false,
  saturday_schedule: '',
  sunday_work: false,
  sunday_schedule: '',
  worked_holidays: false,
  holidays_description: '',
  night_shift: false,
  commute_minutes: '',
  commute_description: '',
  transport_provided_by_employer: false,
  transport_travel_time_minutes: '',
  transport_wait_time_minutes: '',
  transport_vehicle_conditions: '',
  transport_vehicle_description: '',
  ai_hint_jornada: '',

  // FATOS ESPECIAIS
  insalubrity: false,
  insalubrity_degree: '',
  insalubrity_agent: '',
  hazard_pay: false,
  hazard_description: '',
  accidents: [],
  occupational_disease: false,
  disease_description: '',
  moral_harassment: false,
  harassment_description: '',
  coercion_at_dismissal: false,
  coercion_description: '',
  irregular_notice: false,
  notice_description: '',
  stability_reason: '',
  indirect_dismissal: false,
  indirect_dismissal_reason: '',
  data_envio_telegrama: '',          // data de envio do telegrama de rescisão indireta
  data_ajuizamento: '',              // quinquênio conta dela; vazia, de hoje (1.26)
  acoes_anteriores: [],              // ações que interromperam a prescrição (art. 11, § 3º, da CLT)
  prescricao_ressalva: '',           // por que gerar com o biênio vencido
  ai_hint_fatos: '',

  // JURÍDICO & PEDIDOS
  jurisprudencias_selecionadas: [],
  honorarios_pct: 15,
  requerimentos_finais: [],
  pedidos_extras: '',
  estimativa_valor_causa: '',
  ai_hint_juridico: '',

  // VALORES PEDIDOS — map de pedidoId → { enabled, valor, notas, subsidiario_de }
  pedidos: {},
  // Valores já pagos pela reclamada — [{ descricao, valor (decimal POSITIVO), data }]. O acerto por
  // PIX do caso-piloto (relatório do Dr. Lucas de 23/09/2026) não tinha onde entrar; o backend
  // subtrai cada valor do total e da base dos honorários.
  deducoes: [],

  // PROMPT MASTER
  master_prompt: '',
  custom: {},

  // OBSERVAÇÕES GERAIS
  general_observations: '',
  ai_instructions: '',
  responsible_lawyer_id: '',
};

// RG, nome da mãe e telefone ficaram fora: são dados que o cliente costuma não trazer na
// primeira conversa e nunca bloquearam a geração (ver gate_check no backend).
const REQUIRED = [
  'comarca',
  'claimant_name', 'claimant_cpf',
  'claimant_birth_date',
  'claimant_address', 'claimant_city',
];

export const FIELD_LABELS = {
  comarca:              'Comarca',
  claimant_name:        'Nome do reclamante',
  claimant_cpf:         'CPF',
  claimant_rg:          'RG',
  claimant_birth_date:  'Data de nascimento',
  claimant_mother_name: 'Nome da mãe',
  claimant_address:     'Endereço',
  claimant_city:        'Cidade',
  claimant_phones:      'Telefone',
  defendants:           'Reclamado',
  contracts:            'Contrato',
  hire_date:            'Data de admissão',
  termination_date:     'Data de demissão',
  ultimo_dia_trabalhado: 'Último dia efetivamente trabalhado',
  contracted_role:      'Função registrada',
  actual_roles:         'Funções exercidas',
  registered_salary:    'Salário registrado',
  off_payroll_salary:   'Salário por fora',
  remuneracao_periodos: 'Remuneração por período',
  ferias_vencidas_nao_gozadas: 'Férias vencidas não gozadas',
  dismissal_type:       'Tipo de desligamento',
  work_days:            'Dias trabalhados',
  work_day_schedules:   'Horários por dia',
  shift_start:          'Início da jornada',
  shift_end:            'Fim da jornada',
  intrajornada_interval_minutes: 'Intervalo intrajornada',
  point_control_type:   'Controle de ponto',
  point_irregularities: 'Irregularidades no ponto',
  overtime_frequency:   'Frequência de horas extras',
  overtime_description: 'Descrição das horas extras',
  overtime_end_time:    'Horário final das horas extras',
  saturday_work:        'Trabalho aos sábados',
  saturday_schedule:    'Jornada aos sábados',
  sunday_work:          'Trabalho aos domingos',
  sunday_schedule:      'Jornada aos domingos',
  worked_holidays:      'Trabalho em feriados',
  holidays_description: 'Descrição dos feriados',
  night_shift:          'Jornada noturna',
  commute_minutes:      'Tempo total de percurso por dia (ida + volta)',
  commute_description:  'Descrição do percurso',
  responsible_lawyer_id: 'Advogado responsável',
};

function calcCompleteness(data) {
  const rootFilled = REQUIRED.filter(f => {
    const v = data[f];
    return v !== '' && v !== null && v !== undefined;
  }).length;

  const def = data.defendants?.[0];
  const defFilled = def?.name && (def?.cnpj || def?.cpf) ? 2 : 0;

  const ct = data.contracts?.[0];
  // Salário registrado OU extrafolha — casos "sem registro" (rurais) não têm o primeiro.
  const hasPeriodSalary = data.remuneracao_periodos?.some(p => p?.registrado || p?.extrafolha);
  const ctFilled = ct?.hire_date && ct?.contracted_role
    && (ct?.registered_salary || ct?.off_payroll_salary || hasPeriodSalary) ? 3 : 0;

  const jornFilled = (data.shift_start && data.shift_end && data.point_control_type) ? 3 : 0;

  const total  = REQUIRED.length + 2 + 3 + 3;
  const filled = rootFilled + defFilled + ctFilled + jornFilled;

  return {
    pct: Math.round((filled / total) * 100),
    missing: REQUIRED.filter(f => !data[f] && data[f] !== 0),
  };
}

export const useFormStore = create((set, get) => ({
  caseId: null,
  contactId: null,
  formData: { ...EMPTY_FORM },
  completeness: { pct: 0, missing: [...REQUIRED] },
  saveStatus: 'idle',
  isGenerating: false,
  lockMode: false,
  errors: {},
  activeTab: 0,

  setField: (field, value) =>
    set((state) => {
      const newData = { ...state.formData, [field]: value };
      return {
        formData: newData,
        completeness: calcCompleteness(newData),
        errors: { ...state.errors, [field]: undefined },
      };
    }),

  setFields: (fields) =>
    set((state) => {
      const newData = { ...state.formData, ...fields };
      return { formData: newData, completeness: calcCompleteness(newData) };
    }),

  // ── Telefones do reclamante ─────────────────────────────────
  addClaimantPhone: () =>
    set((state) => {
      const phones = [
        ...(state.formData.claimant_phones || []),
        { id: `ph_${Date.now()}`, number: '', type: 'cel', is_whatsapp: false },
      ];
      const newData = { ...state.formData, claimant_phones: phones };
      return { formData: newData, completeness: calcCompleteness(newData) };
    }),

  updateClaimantPhone: (phoneId, updates) =>
    set((state) => {
      const phones = (state.formData.claimant_phones || []).map(p =>
        p.id === phoneId ? { ...p, ...updates } : p
      );
      const newData = { ...state.formData, claimant_phones: phones };
      return { formData: newData, completeness: calcCompleteness(newData) };
    }),

  removeClaimantPhone: (phoneId) =>
    set((state) => {
      const phones = (state.formData.claimant_phones || []).filter(p => p.id !== phoneId);
      const newData = { ...state.formData, claimant_phones: phones };
      return { formData: newData, completeness: calcCompleteness(newData) };
    }),

  // ── Reclamados ─────────────────────────────────────────────
  addDefendant: () =>
    set((state) => {
      const id = `def_${Date.now()}`;
      const newDef = {
        id, name: '', cnpj: '', cpf: '', gender: '', cei: '',
        address: '', neighborhood: '', city: '', state: '', zip: '',
        is_primary: false, relationship: 'grupo_economico',
        order_num: state.formData.defendants.length + 1,
        phones: [], extra_info: '',
      };
      const newData = { ...state.formData, defendants: [...state.formData.defendants, newDef] };
      return { formData: newData };
    }),

  updateDefendant: (defId, updates) =>
    set((state) => {
      const defendants = state.formData.defendants.map(d =>
        d.id === defId ? { ...d, ...updates } : d
      );
      return { formData: { ...state.formData, defendants } };
    }),

  removeDefendant: (defId) =>
    set((state) => {
      const defendants = state.formData.defendants.filter(d => d.id !== defId);
      return { formData: { ...state.formData, defendants } };
    }),

  setPrimaryDefendant: (defId) =>
    set((state) => {
      const defendants = state.formData.defendants.map(d => ({
        ...d, is_primary: d.id === defId,
      }));
      return { formData: { ...state.formData, defendants } };
    }),

  // ── Contratos ──────────────────────────────────────────────
  addContract: () =>
    set((state) => {
      const id = `ct_${Date.now()}`;
      const firstDefId = state.formData.defendants[0]?.id || '';
      const newCt = {
        id, defendant_id: firstDefId,
        hire_date: '', termination_date: '', ultimo_dia_trabalhado: '', contracted_role: '',
        aviso_previo_modalidade: '', termino_inclui_aviso: false,
        actual_roles: '', registered_salary: '', off_payroll_salary: '',
        dismissal_type: '', registered_in_ctps: true, fgts_deposited: true,
        food_benefit: false, transport_benefit: false,
        health_plan: false, meal_benefit: false,
        other_benefits: '', severance_amount: '',
        severance_payment_date: '', notes: '',
        order_num: state.formData.contracts.length + 1,
        regime_contratual: '', jornada_contratual_diaria_horas: '', jornada_contratual_semanal_horas: '',
      };
      const newData = { ...state.formData, contracts: [...state.formData.contracts, newCt] };
      return { formData: newData };
    }),

  updateContract: (ctId, updates) =>
    set((state) => {
      const contracts = state.formData.contracts.map(c =>
        c.id === ctId ? { ...c, ...updates } : c
      );
      return { formData: { ...state.formData, contracts } };
    }),

  removeContract: (ctId) =>
    set((state) => {
      const contracts = state.formData.contracts.filter(c => c.id !== ctId);
      return { formData: { ...state.formData, contracts } };
    }),

  // ── Acidentes ──────────────────────────────────────────────
  addAccident: () =>
    set((state) => {
      const newAcc = {
        id: `acc_${Date.now()}`,
        date: '', time: '', location: '',
        witnesses: '', description: '', ai_instruction: '',
      };
      const newData = { ...state.formData, accidents: [...(state.formData.accidents || []), newAcc] };
      return { formData: newData };
    }),

  updateAccident: (accId, updates) =>
    set((state) => {
      const accidents = (state.formData.accidents || []).map(a =>
        a.id === accId ? { ...a, ...updates } : a
      );
      return { formData: { ...state.formData, accidents } };
    }),

  removeAccident: (accId) =>
    set((state) => {
      const accidents = (state.formData.accidents || []).filter(a => a.id !== accId);
      return { formData: { ...state.formData, accidents } };
    }),

  // ── Pedido (valores) ────────────────────────────────────────
  updatePedido: (pedidoId, updates) =>
    set((state) => {
      const pedidos = { ...state.formData.pedidos, [pedidoId]: { ...(state.formData.pedidos[pedidoId] || {}), ...updates } };
      return { formData: { ...state.formData, pedidos } };
    }),

  // ── Geral ──────────────────────────────────────────────────
  setContact: (id) => set({ contactId: id }),
  setCaseId: (id) => set({ caseId: id }),
  setActiveTab: (i) => set({ activeTab: i }),
  setSaveStatus: (s) => set({ saveStatus: s }),
  setIsGenerating: (v) => set({ isGenerating: v }),
  setLockMode: (v) => set({ lockMode: v }),
  setErrors: (e) => set({ errors: e }),

  loadFromCase: (caseData) => {
    const formData = { ...EMPTY_FORM, ...(caseData.intake_form || {}) };
    // Compatibilidade: migrar claimant_phone (string) → claimant_phones
    if (!formData.claimant_phones || !formData.claimant_phones.length) {
      const legacyPhone = formData.claimant_phone || '';
      formData.claimant_phones = [{ id: 'ph_1', number: legacyPhone, type: 'cel', is_whatsapp: true }];
      delete formData.claimant_phone;
    }
    if (!formData.defendants || !formData.defendants.length) {
      formData.defendants = [...EMPTY_FORM.defendants];
    } else {
      // Garantir phones/extra_info em defendants legados
      formData.defendants = formData.defendants.map(d => ({
        phones: [], extra_info: '', neighborhood: '', ...d,
      }));
    }
    if (!formData.contracts || !formData.contracts.length) {
      formData.contracts = [...EMPTY_FORM.contracts];
    }
    if (!formData.accidents) formData.accidents = [];
    if (!formData.pedidos) formData.pedidos = {};
    set({
      caseId: caseData.id,
      contactId: caseData.contact_id,
      formData,
      completeness: calcCompleteness(formData),
    });
  },

  autofillFromMedia: (extracted) => {
    const fields = {};
    if (extracted.cpf && !get().formData.claimant_cpf) fields.claimant_cpf = extracted.cpf;
    if (extracted.full_name && !get().formData.claimant_name) fields.claimant_name = extracted.full_name;
    if (extracted.client_phone) {
      const phones = get().formData.claimant_phones || [];
      if (!phones[0]?.number) {
        fields.claimant_phones = phones.length > 0
          ? phones.map((p, i) => i === 0 ? { ...p, number: extracted.client_phone } : p)
          : [{ id: 'ph_1', number: extracted.client_phone, type: 'cel', is_whatsapp: true }];
      }
    }
    if (extracted.employer_name)
      get().updateDefendant(get().formData.defendants[0]?.id, { name: extracted.employer_name });
    if (extracted.employer_cnpj)
      get().updateDefendant(get().formData.defendants[0]?.id, { cnpj: extracted.employer_cnpj });
    if (extracted.hire_date)
      get().updateContract(get().formData.contracts[0]?.id, { hire_date: extracted.hire_date });
    if (extracted.termination_date)
      get().updateContract(get().formData.contracts[0]?.id, { termination_date: extracted.termination_date });
    if (Object.keys(fields).length) get().setFields(fields);
    return Object.keys(fields).length;
  },

  reset: () =>
    set({
      caseId: null,
      contactId: null,
      formData: { ...EMPTY_FORM, claimant_phones: [{ id: 'ph_1', number: '', type: 'cel', is_whatsapp: true }] },
      completeness: { pct: 0, missing: [...REQUIRED] },
      saveStatus: 'idle',
      isGenerating: false,
      lockMode: false,
      errors: {},
      activeTab: 0,
    }),
}));
